import { Form, Modal, Spin, Checkbox } from "antd";
import { useUpdatePreEntitlementRecordsMutation } from "../../store/is/preentitlementrecordsapi";
import {  useUpdateEntitlementCreditBundlesMutation } from "../../store/is/entitlementCreditBundleApi";
import { useState } from "react";
import { useAddAssignmentMutation, useGetAssignmentByParamQuery } from "store/is/assignmentapi";

export default function CausalityDeclaration({
  recordsRequiringCausality, causalitySubmitCallback, setRecordsRequiringCausality, buyer
}) {
  const [causalityDeclarationForm] = Form.useForm();
  const contractualRelationship = Form.useWatch('contractualRelationship', causalityDeclarationForm);
  const preExistingRelationship = Form.useWatch('preExistingRelationship', causalityDeclarationForm);
  const noDoubleClaiming = Form.useWatch('noDoubleClaiming', causalityDeclarationForm);
  const allCausalityChecked = contractualRelationship && preExistingRelationship && noDoubleClaiming;
  const [
    updatePreEntitlementRecords,
  ] = useUpdatePreEntitlementRecordsMutation();
  const [
    updateBundles
  ] = useUpdateEntitlementCreditBundlesMutation();
  const [addAssignment] = useAddAssignmentMutation();
  const { project_id } = recordsRequiringCausality[0].asset_details || recordsRequiringCausality[0];
  const { data: existingAssignments } = useGetAssignmentByParamQuery({
    project_id: project_id,
    assignee_type: "Buyer",
  });

  const [isSpinning, setIsSpinning] = useState(false);

  const addCausalityDeclarationToEntitlements = async () => {
    const data = recordsRequiringCausality.map(record => ({
      _id: record._id,
      yield_id: record.yield_id,
      status: record.status,
      final_tradable_cert_uuid: record.final_tradable_cert_uuid,
      no_of_entitlement_record: record.no_of_entitlement_record,
      is_updated_to_blockchain: record.is_updated_to_blockchain,
      causality_declared_at: true,
      organization_id: record.organization_id
    }));
    return await updatePreEntitlementRecords(data);
  }

  const addCausalityDeclarationToBundles = async () => {
    const data = recordsRequiringCausality.map(record => ({
      uuid: record._id,
      no_of_credits: record.no_of_credits,
      causality_declared_at: true
    }))
    return await updateBundles(data);
  }

  const addCausalityDeclarationToRecords = async () => {
    if (recordsRequiringCausality.some(record => record.no_of_entitlement_record)) {
      await addCausalityDeclarationToEntitlements();
    } else if (recordsRequiringCausality.some(record => record.credit_bundle_uuid)) {
      await addCausalityDeclarationToBundles()
    }
  }

  const addBuyerAssignmentToProject = async () => {
    const existingAssignmentsWithBuyer = existingAssignments?.filter(assignment => assignment.organization === buyer._id);
    if (existingAssignmentsWithBuyer?.length === 0) {
      const assignment = {
        project_id,
        organization: buyer._id,
        verification_status: 'notverified',
        assignee_type: 'Buyer',
      }
      await addAssignment(assignment);
    }
  }

  const handleCausalityDeclarationConfirm = async () => {
    await causalityDeclarationForm.validateFields();
    setIsSpinning(true);
    await addBuyerAssignmentToProject();
    await addCausalityDeclarationToRecords();
    setRecordsRequiringCausality([]);
    await causalitySubmitCallback();
  }

  return (
    <Modal
      title="Confirm Buyer Relationship"
      open={recordsRequiringCausality.length > 0}
      onCancel={() => setRecordsRequiringCausality([])}
      onOk={handleCausalityDeclarationConfirm}
      okText="Confirm and Transfer"
      okButtonProps={{ disabled: !allCausalityChecked }}
    >
      <Spin spinning={isSpinning}>
        <p>Please confirm the following statements about the relationship between this project and <span className="font-semibold">{buyer?.name}</span> before completing the transfer.</p>
        <Form form={causalityDeclarationForm}>
          <Form.Item name="contractualRelationship" valuePropName="checked">
            <div>
              <Checkbox>
                <span className="font-semibold block">Contractual relationship</span>
                I confirm that a contractual or equivalent agreement exists between the project and <span className="font-semibold">{buyer?.name}</span> for the purchase of emission reduction outcomes from this project.
              </Checkbox>
            </div>
          </Form.Item>
          <Form.Item name="preExistingRelationship" valuePropName="checked">
            <Checkbox>
              <span className="font-semibold block">Pre-existing relationship</span>
              I confirm that <span className="font-semibold">{buyer?.name}</span> involvement or commitment was established before or during the start of project implementation, and that this relationship contributed to the project coming about or continuing to operate.
            </Checkbox>
          </Form.Item>
          <Form.Item name="noDoubleClaiming" valuePropName="checked">
            <Checkbox>
              <span className="font-semibold block">No double-claiming</span>
              I confirm that <span className="font-semibold">{buyer?.name}</span> contribution to the project has not been registered or claimed in any other registry or scheme.
            </Checkbox>
          </Form.Item>
        </Form>
      </Spin>
    </Modal>

  )
}